var CheckboxModule = (function () {
    function CheckboxModule() {
    }
    return CheckboxModule;
}());
export { CheckboxModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/checkbox/checkbox.module.ts.pre-build-optimizer.js